import styled, { css } from 'styled-components';

const LoadingSpinnerStyled = styled.div`
  ${() => {
    return css`
      box-shadow: 0px 0.125em 0.688em rgba(0, 0, 0, 0.15);
      border: 0.125em solid var(--primary-color);
      background: var(--primary-color);
      border-radius: 50%;
      width: 3em;
      height: 3em;
      display: flex;
      align-items: center;
      justify-content: center;
      > div:first-child {
        width: 2.5em;
        height: 2.5em;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        background: var(--primary-color);
        border: 0.188em solid var(--color-midnight);
        border-top: 0.188em solid var(--color-white);
      }
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `;
  }}
`;

export default LoadingSpinnerStyled;
